import { tv, type VariantProps } from "@ui/lib/tv";
import { Button, type ButtonProps } from "@ui/primitives/Button";
import { composeRenderProps } from "@ui/primitives/shared";

const softButton = tv({
  base: "flex cursor-pointer items-center justify-center rounded-full bg-neutral-50 hover:bg-neutral-100",
  defaultVariants: {
    size: "sm",
  },
  variants: {
    size: {
      sm: "size-8",
      md: "size-10",
    },
  },
});

type SoftButtonVariants = VariantProps<typeof softButton>;

export type SoftButtonProps = ButtonProps & SoftButtonVariants;

export function SoftButton({ size, ...props }: SoftButtonProps) {
  return (
    <Button
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        softButton({ ...renderProps, size, className }),
      )}
    />
  );
}
